import React from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadAbbr } from './DownloadAbbr';
import { formatNumber } from '../../../StringUtils';

type DownloadByteUnit = {
  bytes: number;
  decimals: number;
};

/**
 * This component transfers bytes into the appropriate kb, mb or whatever units
 *  and returns that in the correct semantic way
 */
export function DownloadByteUnit({ bytes = 0, decimals = 2 }) {
  const { t } = useTranslation('DownloadByteUnit');

  if (bytes === 0 || !bytes) {
    return (
      <>
        0 <span lang="en">Bytes</span>
      </>
    );
  }
  const k = 1024;
  // we prefer uppercase here because these are abbreviations
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const num = parseFloat((bytes / k ** i).toFixed(decimals));

  return (
    <>
      {`${formatNumber(num)} `}
      <DownloadAbbr text={sizes[i]} title={t(sizes[i])} />
    </>
  );
}
